import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  id: string;
  goodItemId: string;
  file: File;
}
export const useManuallySetScreenshot = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, goodItemId, file }: HookProps) => {
      if (goodItemId?.length && file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('goodItemId', goodItemId);
        const { declaration } = await request({
          path: `declarations/${id}/manuallySetScreenshot`,
          method: 'POST',
          authenticate: true,
          dataObject: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
      }
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['declaration', variables.id] });
      toast.success('Screenshot was set successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error setting the screenshot!`);
    },
  });
};
